import service from '@/services/company/CompanyService'

export const companyModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    companyList: [],
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_LIST(state, payload) {
      state.companyList = payload.data
      state.pagination.current_page = payload.current_page
      state.pagination.last_page = payload.last_page
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getCompanies({ commit }, payload) {
      try {
        commit('SET_LOADING')
        let response = await service.getCompanies(payload)
        commit('SET_LIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },
    async getCompany(context, payload) {
      let data = await service.getCompany(payload)

      return data
    },
    async quickRegister({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.quickRegister(request)

      dispatch('getCompanies', {
        page: state.pagination.current_page,
      })

      return status
    },

    async insertCompany({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.insert(request)

      dispatch('getCompanies', {
        page: state.pagination.current_page,
      })

      return status
    },

    async insertRemoteCompany(context, payload) {
      let request = service.translateToFirebird(payload)
      let formData = new FormData()
      formData.append('data', JSON.stringify(request))
      if (payload.foto) {
        formData.append('file', payload.foto)
      }

      const { status } = await service.insertRemoteCompany(
        formData,
        'company-remote'
      )

      return status
    },

    async updateCompany({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.update(request, payload.id)

      dispatch('getCompanies', {
        page: state.pagination.current_page,
      })
      return status
    },

    async deleteCompany({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)

      dispatch('getCompanies', {
        page: state.pagination.current_page,
      })
      return status
    },
  },

  getters: {
    getComboBoxList: (state) => {
      let comboBox = state.companyList.map((company) => {
        return {
          CODIGO: parseInt(company.CODIGO),
          DESCRICAO:
            company.CODIGO +
            ' - ' +
            company.NOME +
            (company.CGC ? ' - ' + company.CGC : ''),
          CGC: company.CGC,
          obsBalcao: company.OBSO4,
          TIPOPRECO: company.TIPOPRECO,
          tipoVenda: company.tipo_venda,
          bloqueado: company.BLOQUEADO ? true : false,
        }
      })
      return comboBox
    },
  },
}
